<div class="error-page">
    <!-- Hero Section Begin -->
    <section class="error-hero-section">
        <div class="hero-background">
            <!-- Background gradient overlay -->
            <div class="gradient-overlay"></div>

            <!-- Animated particles/effects -->
            <div class="particles"></div>
        </div>



        <div class="container">
            <div class="error-content">
                <div class="error-icon">
                    <img src="assets/img/svg/gamepad.svg" alt="Game Controller">
                </div>
                <h1 class="error-title">404</h1>
                <h2 class="error-subtitle">PAGE NOT FOUND</h2>
                <p class="error-message">
                    <span class="highlight">Oops! The page you're looking for doesn't exist.</span> 
                    It might have been moved or deleted.
                </p>
                <div class="error-buttons">
                    <button class="btn btn-primary" (click)="directToHome()">BACK TO HOME</button>
                </div>
            </div>
        </div>
    </section>
</div>
